function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
class BaseLoggingModule {
  init(config, sdkContext) {
    var _sdkContext_debug;
    this.debug = (_sdkContext_debug = sdkContext === null || sdkContext === void 0 ? void 0 : sdkContext.debug) !== null && _sdkContext_debug !== void 0 ? _sdkContext_debug : false;
    var _config_meta;
    this.meta = (_config_meta = config === null || config === void 0 ? void 0 : config.meta) !== null && _config_meta !== void 0 ? _config_meta : {};
  }
  send(event) {
  }
  info(message, data) {
  }
  warn(message, data) {
  }
  error(message, data) {
  }
  getMeta(...args) {
    return _object_spread({}, this.meta);
  }
  reportCUJ(name, status, data) {
  }
  destruct() {
  }
  constructor() {
    this.debug = false;
    this.meta = {};
  }
}
var BaseLoggingModule_default = BaseLoggingModule;
export {
  BaseLoggingModule_default as default
};

//# sourceMappingURL=BaseLoggingModule.js.map